const Footer = () => {
    return (
        <footer className="center">
            <p>Created by m-webdesign &copy; 2024</p>
        </footer>
    )
}

export default Footer;